// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"441":"flatpickr-dark","565":"flatpickr-light"}[chunkId] + ".js";
};